import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

const markFieldsAsTouched = (controls: any) => {
  Object.keys(controls).forEach(
    (key: string) => {
      const control = controls[key];
      if (control instanceof FormGroup) {
        markFieldsAsTouched(control);
      } else {
        control.markAsTouched();
      }
    }
  );
};

@Directive({
  selector: '[ltgSubmit]'
})
export class SubmitDirective {
  @Input('ltgSubmit') form: FormGroup;

  @HostBinding('class.disabled') disabled() {
    return this.form.invalid;
  }

  @HostListener('click', ['$event']) click(event: MouseEvent) {
    markFieldsAsTouched(this.form.controls);
    if (this.form.invalid) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/shared/directives/submit.directive.ts